"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExceptionCodesApi;
(function (ExceptionCodesApi) {
    ExceptionCodesApi["UNKNOWN_ERROR"] = "unknown_error";
    ExceptionCodesApi["INTERNAL_ERROR"] = "internal_error";
    ExceptionCodesApi["ACCESS_DENIED"] = "access_denied";
    ExceptionCodesApi["EXPIRED_TOKEN"] = "expired_token";
    ExceptionCodesApi["INVALID_TOKEN"] = "invalid_token";
    ExceptionCodesApi["CANNOT_DECRYPT"] = "cannot_decrypt";
    ExceptionCodesApi["WEAK_PASSWORD"] = "weak_password";
    ExceptionCodesApi["INVALID_TOKEN_ID"] = "invalid_token_id";
    ExceptionCodesApi["INVALID_TOKEN_CONTENTS"] = "invalid_token_contents";
    ExceptionCodesApi["INVALID_SIGNATURE"] = "invalid_signature";
    ExceptionCodesApi["INVALID_PERMISSION"] = "invalid_permission";
    ExceptionCodesApi["HMAC_FAILED"] = "hmac_failed";
    ExceptionCodesApi["INVALID_OAUTH_PROVIDER"] = "invalid_oauth_provider";
    ExceptionCodesApi["OAUTH_FAILED"] = "oauth_failed";
    ExceptionCodesApi["MISSING_USER"] = "missing_user";
    ExceptionCodesApi["RESOURCE_EXISTS"] = "resource_exists";
    ExceptionCodesApi["INVALID_BLOB_ID"] = "invalid_blob_id";
    ExceptionCodesApi["DECRYPT_FAILED"] = "decrypt_failed";
    ExceptionCodesApi["FASTLOGIN_INVALID"] = "fastlogin_invalid";
    ExceptionCodesApi["FASTLOGIN_EXPIRED"] = "fastlogin_expired";
    ExceptionCodesApi["FORCE_RESET_PASSWORD"] = "force_reset_password";
    ExceptionCodesApi["BLOCKED_TWO_FACTOR"] = "blocked_two_factor";
    ExceptionCodesApi["NEW_DEVICE_2FA"] = "new_device_2fa";
    ExceptionCodesApi["INVALID_DEVICE_TOKEN"] = "invalid_device_token";
    ExceptionCodesApi["EXPIRED_PRELOGIN_TOKEN"] = "expired_prelogin_token";
    ExceptionCodesApi["INVALID_PRELOGIN_TOKEN"] = "invalid_prelogin_token";
    ExceptionCodesApi["INVALID_TOTP"] = "invalid_totp";
    ExceptionCodesApi["TOKEN_MISMATCH"] = "token_mismatch";
    ExceptionCodesApi["INVALID_USERNAME"] = "invalid_username";
    ExceptionCodesApi["MISSING_FIELD"] = "missing_field";
    ExceptionCodesApi["MISSING_RESPONSE"] = "missing_response";
})(ExceptionCodesApi = exports.ExceptionCodesApi || (exports.ExceptionCodesApi = {}));
var ExternalIdentityProviderNameApi;
(function (ExternalIdentityProviderNameApi) {
    ExternalIdentityProviderNameApi["ARROW"] = "arrow";
})(ExternalIdentityProviderNameApi = exports.ExternalIdentityProviderNameApi || (exports.ExternalIdentityProviderNameApi = {}));
var UserPermissionsApi;
(function (UserPermissionsApi) {
    UserPermissionsApi["GAF"] = "gaf";
    UserPermissionsApi["GAF_SERVICES"] = "gaf_services";
    UserPermissionsApi["API"] = "api";
    UserPermissionsApi["ESCALATED"] = "escalated";
    UserPermissionsApi["GAF_FILES"] = "gaf_files";
})(UserPermissionsApi = exports.UserPermissionsApi || (exports.UserPermissionsApi = {}));
var AdminPermissionsApi;
(function (AdminPermissionsApi) {
    AdminPermissionsApi["GAF_ADMIN"] = "gaf_admin";
    AdminPermissionsApi["GAF_ADMIN_KYC"] = "gaf_admin_kyc";
    AdminPermissionsApi["GAF_ADMIN_FINOPS"] = "gaf_admin_finops";
    AdminPermissionsApi["GAF_ADMIN_MANAGE"] = "gaf_admin_manage";
    AdminPermissionsApi["GAF_ADMIN_ASSISTED_PROJECTS"] = "gaf_admin_assisted_projects";
})(AdminPermissionsApi = exports.AdminPermissionsApi || (exports.AdminPermissionsApi = {}));
var ServiceIdApi;
(function (ServiceIdApi) {
    ServiceIdApi["NONE"] = "none";
    ServiceIdApi["AUTH_CA"] = "auth_ca";
    ServiceIdApi["AUTH_SESSION"] = "auth_session";
    ServiceIdApi["AUTH_USER"] = "auth_user";
    ServiceIdApi["AUTH_USER_REST"] = "auth_user_rest";
    ServiceIdApi["AUTH_ADMIN"] = "auth_admin";
    ServiceIdApi["AUTH_ADMIN_REST"] = "auth_admin_rest";
    ServiceIdApi["AUTH_BLOB"] = "auth_blob";
    ServiceIdApi["AUTH_LOGGER"] = "auth_logger";
    ServiceIdApi["AUTH_FASTLOGIN"] = "auth_fastlogin";
    ServiceIdApi["FILESERVICE_META"] = "fileservice_meta";
    ServiceIdApi["FILESERVICE_KEY"] = "fileservice_key";
    ServiceIdApi["GAF"] = "gaf";
    ServiceIdApi["GAF_2"] = "gaf_2";
    ServiceIdApi["REST_API"] = "rest_api";
    ServiceIdApi["NOTIFY_PERSIST"] = "notify_persist";
    ServiceIdApi["NOTIFICATIONS"] = "notifications";
    ServiceIdApi["REALEMAIL_RESTRICTED"] = "realemail_restricted";
    ServiceIdApi["CONTACTS"] = "contacts";
    ServiceIdApi["REALEMAIL_BLACKLIST_CONSUMER"] = "realemail_blacklist_consumer";
    ServiceIdApi["CLASSIFIER_PROJECT"] = "classifier_project";
    ServiceIdApi["TRANSLATIONS"] = "translations";
    ServiceIdApi["GAF_SYNC"] = "gaf_sync";
    ServiceIdApi["MEMBERSHIPS"] = "memberships";
    ServiceIdApi["MESSAGING_SMTP"] = "messaging_smtp";
    ServiceIdApi["TASKQUEUE"] = "taskqueue";
    ServiceIdApi["PROJECTS"] = "projects";
    ServiceIdApi["SCAVENGER"] = "scavenger";
    ServiceIdApi["USERS"] = "users";
    ServiceIdApi["WAUTH_HSO"] = "wauth_hso";
    ServiceIdApi["ABTEST"] = "abtest";
    ServiceIdApi["DATA_ACCESS_WORKER"] = "data_access_worker";
    ServiceIdApi["TEST1"] = "test1";
    ServiceIdApi["TEST2"] = "test2";
    ServiceIdApi["HEALTHCHECK1"] = "healthcheck1";
    ServiceIdApi["HEALTHCHECK2"] = "healthcheck2";
})(ServiceIdApi = exports.ServiceIdApi || (exports.ServiceIdApi = {}));
var TokenTypeApi;
(function (TokenTypeApi) {
    TokenTypeApi["USER"] = "user";
    TokenTypeApi["ADMIN"] = "admin";
    TokenTypeApi["ADMIN_USER"] = "admin_user";
    TokenTypeApi["APP"] = "app";
    TokenTypeApi["API"] = "api";
})(TokenTypeApi = exports.TokenTypeApi || (exports.TokenTypeApi = {}));
var ResponseStatusApi;
(function (ResponseStatusApi) {
    ResponseStatusApi["SUCCESS"] = "success";
    ResponseStatusApi["DENIED"] = "denied";
})(ResponseStatusApi = exports.ResponseStatusApi || (exports.ResponseStatusApi = {}));
var TotpMethodsApi;
(function (TotpMethodsApi) {
    TotpMethodsApi["EMAIL"] = "email";
    TotpMethodsApi["SMS"] = "sms";
    TotpMethodsApi["GENERATOR"] = "generator";
    TotpMethodsApi["APP_PUSH"] = "app_push";
})(TotpMethodsApi = exports.TotpMethodsApi || (exports.TotpMethodsApi = {}));
var OAuthApi;
(function (OAuthApi) {
    OAuthApi["FACEBOOK"] = "facebook";
    OAuthApi["FACEBOOK_MOBILE"] = "facebook_mobile";
    OAuthApi["LINKEDIN"] = "linkedin";
    OAuthApi["FACEBOOK_APP"] = "facebook_app";
    OAuthApi["APPLE"] = "apple";
})(OAuthApi = exports.OAuthApi || (exports.OAuthApi = {}));
var HashProvidersApi;
(function (HashProvidersApi) {
    HashProvidersApi["MD5"] = "md5";
    HashProvidersApi["LEGACY"] = "legacy";
    HashProvidersApi["BCRYPT"] = "bcrypt";
    HashProvidersApi["WARRIOR"] = "warrior";
})(HashProvidersApi = exports.HashProvidersApi || (exports.HashProvidersApi = {}));
//# sourceMappingURL=auth.js.map